(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarComponent extends HTMLElement {
    #current = 0;
    #interval = undefined;

    connectedCallback() {
      this.addEventListener('mouseenter', this.suspend.bind(this));
      this.addEventListener('mouseleave', this.resume.bind(this));
      document.addEventListener('visibilitychange', this.#handleVisibilityChange.bind(this));

      const prevBtn = this.querySelector('.announcement-bar__control--prev');
      const nextBtn = this.querySelector('.announcement-bar__control--next');

      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previous();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.next();
        });
      }

      this.play();
    }

    next() {
      this.setAttribute('data-direction', 'next');
      this.current += 1;
    }

    previous() {
      this.setAttribute('data-direction', 'prev');
      this.current -= 1;
    }

    play(interval = this.autoplayInterval) {
      if (!this.autoplay) return;
      this.paused = false;

      this.#interval = setInterval(() => {
        if (this.matches(':hover') || document.hidden) return;
        this.next();
      }, interval);
    }

    pause() {
      this.paused = true;
      this.suspend();
    }

    get paused() {
      return this.hasAttribute('paused');
    }

    set paused(paused) {
      this.toggleAttribute('paused', paused);
    }

    suspend() {
      if (this.#interval) {
        clearInterval(this.#interval);
        this.#interval = undefined;
      }
    }

    resume() {
      if (!this.autoplay || this.paused) return;
      this.pause();
      this.play();
    }

    get autoplay() {
      return Boolean(this.autoplayInterval);
    }

    get autoplayInterval() {
      const interval = this.getAttribute('autoplay');
      const value = parseInt(`${interval}`, 10);
      if (Number.isNaN(value)) return undefined;
      return value * 1000;
    }

    get slides() {
      return Array.from(this.querySelectorAll('.announcement-bar__slide'));
    }

    get current() {
      return this.#current;
    }

    set current(current) {
      this.#current = current;
      const slides = this.slides;
      if (!slides.length) return;

      let relativeIndex = current % slides.length;
      if (relativeIndex < 0) {
        relativeIndex += slides.length;
      }

      slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', `${index !== relativeIndex}`);
      });
    }

    #handleVisibilityChange() {
      if (document.hidden) {
        this.pause();
      } else {
        this.resume();
      }
    }
  }

  if (!customElements.get('announcement-bar-component')) {
    customElements.define('announcement-bar-component', AnnouncementBarComponent);
  }

  (function () {

    const menuOpenBtn = document.getElementById('fullscreen-menu-open');
    const menuCloseBtn = document.getElementById('fullscreen-menu-close');
    const menuOverlay = document.getElementById('fullscreen-menu');
    if (!menuOpenBtn || !menuCloseBtn || !menuOverlay) return;

    function openMenu() {
      menuOverlay.classList.add('is-open');
      document.documentElement.classList.add('menu-is-open');
      document.body.classList.add('menu-is-open');
    }
    function closeMenu() {
      menuOverlay.classList.remove('is-open');
      document.documentElement.classList.remove('menu-is-open');
      document.body.classList.remove('menu-is-open');
    }

    menuOpenBtn.addEventListener('click', openMenu);
    menuCloseBtn.addEventListener('click', closeMenu);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); });

    // SMART STICKY LOGIC
    const header = document.getElementById('site-header');
    const spacer = document.getElementById('site-header-spacer');
    
    if (header) {
      if (header.classList.contains('fixed')) {
        let lastScrollY = window.pageYOffset || document.documentElement.scrollTop;
        const transparencyAllowed = header.classList.contains('header--transparent-allowed');

        // Initial setup for spacer height
        const setSpacerHeight = () => {
          if (spacer && !spacer.classList.contains('hidden')) {
            spacer.style.height = header.offsetHeight + 'px';
          }
        };

        const updateHeader = () => {
          const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
          const scrollDiff = currentScrollY - lastScrollY;

          // 1. Transparency Logic
          if (transparencyAllowed) {
            if (currentScrollY <= 20) {
              header.classList.add('is-transparent');
            } else {
              header.classList.remove('is-transparent');
            }
          }

          // 2. Hide/Show Logic
          if (currentScrollY <= 80) {
            // At top: Force show
            header.classList.remove('header--hidden');
          } else if (scrollDiff > 15) {
            // Scroll down: Hide
            header.classList.add('header--hidden');
          } else if (scrollDiff < -5) {
            // Scroll up: Show
            header.classList.remove('header--hidden');
          }

          lastScrollY = Math.max(0, currentScrollY);
        };

        window.addEventListener('scroll', updateHeader, { passive: true });
        window.addEventListener('resize', setSpacerHeight);
        
        // Run once on load
        setSpacerHeight();
        updateHeader();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
